import { create } from "zustand";

export const AgritourismStore = create((set) => ({
  agroMapImage: null,

  setAgroMapImage: (img) => set({ agroMapImage: img }),

  agroturismoValue: null,
  interesseAgroturismoValue: null,
  dificuldadeAgroturismoValue: null,
  formaRendaValue: null,

  agroturismoImage: null,
  interesseAgroturismoImage: null,
  dificuldadeAgroturismoImage: null,
  formaRendaImage: null,

  setAgroturismoValue: (val) => set({ agroturismoValue: val }),
  setInteresseAgroturismoValue: (val) =>
    set({ interesseAgroturismoValue: val }),
  setDificuldadeAgroturismoValue: (val) =>
    set({ dificuldadeAgroturismoValue: val }),
  setFormaRendaValue: (val) => set({ formaRendaValue: val }),

  setAgroturismoImage: (img) => set({ agroturismoImage: img }),
  setInteresseAgroturismoImage: (img) =>
    set({ interesseAgroturismoImage: img }),
  setDificuldadeAgroturismoImage: (img) =>
    set({ dificuldadeAgroturismoImage: img }),
  setFormaRendaImage: (img) => set({ formaRendaImage: img }),

  reset: () =>
    set({
      agroturismoValue: null,
      interesseAgroturismoValue: null,
      dificuldadeAgroturismoValue: null,
      formaRendaValue: null,
    }),
}));
